import { useState } from "react";
import { Briefcase } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../components/ui/accordion";
import CategoryPageShell from "../../../components/workspace/CategoryPageShell";
import { useHashAccordion } from "../../../hooks/useHashAccordion";
import { WORKING_ITEMS } from "../../../data/proCarerCircleContent";

export default function WorkingIndependently() {
  const [openItem, setOpenItem] = useState("");
  useHashAccordion(WORKING_ITEMS.map((i) => i.id), setOpenItem);

  return (
    <CategoryPageShell
      testId="pcc-category-working-independently"
      slug="working-independently"
      eyebrow="Working Independently"
      title="Boundaries, communication and saying no."
      description="Practical guidance for the parts of independent care that aren't taught — but matter just as much as the practical skills."
    >
      <section className="min-w-0">
        <div className="mb-5 flex items-center gap-2 text-teal">
          <Briefcase className="w-4 h-4" strokeWidth={2} />
          <span className="text-sm font-semibold uppercase tracking-wide">5 articles</span>
        </div>
        <Accordion type="single" collapsible value={openItem} onValueChange={setOpenItem} className="space-y-3" data-testid="working-accordion">
          {WORKING_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <AccordionItem key={item.id} value={item.id} id={item.id} className="rounded-2xl border border-slate-200 bg-white px-5 md:px-7 scroll-mt-24 min-w-0">
                <AccordionTrigger className="py-5 hover:no-underline">
                  <span className="flex items-center gap-3 text-left">
                    <Icon className="w-5 h-5 text-teal shrink-0" strokeWidth={1.75} />
                    <span className="flex flex-col">
                      <span className="font-display text-lg font-semibold">{item.title}</span>
                      <span className="text-sm text-ink-muted font-normal">{item.summary}</span>
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pt-1 text-base leading-relaxed">{item.body}</AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </section>
    </CategoryPageShell>
  );
}
